import { Component } from '@angular/core';
import { ListSpecialPaymentsGracePeriodOpenQuoteWrapper } from '@app/pages/quote/open-quote/deals/list-special-payments-periods/list-special-payments-gp-wrapepr.component';
import { NotificationService } from '@app/services/notifications.service';

@Component({
  selector: 'open-list-special-payments-grace-period-mobile',
  templateUrl: './list-special-payments-gp-mobile.component.html',
  styleUrls: ['./list-special-payments-gp-mobile.component.scss'],
})
export class ListSpecialPaymentsGracePeriodOpenMobileComponent extends ListSpecialPaymentsGracePeriodOpenQuoteWrapper {
  constructor(notificationService: NotificationService) {
    super(notificationService);
  }
}
